export enum EContactsType {
	contacts = "contacts",
	groups = "groups",
	contactsAndGroups = "contactsAndGroups"
}